import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import * as api from "../../../services/apiService"; // Import the API service
import './FormPage.scss';

const hardcodedImages = [
  "/images/TL1.jpg", 
  "/images/TL2.jpg", 
  "/images/TL3.jpg", 
  "/images/TL4.jpg", 
  "/images/TL5.jpg", 
  "/images/TL6.jpg", 
];

function FormPage() {
  const [formsList, setFormsList] = useState([]);

  useEffect(() => {
    async function fetchFormsData() {
      try {
        const response = await api.getForms(); 
        const data = await response.json();
        
        setFormsList(data);
      } catch (error) {
        console.error("Error fetching forms:", error);
      }
    }

    fetchFormsData();
  }, []);

  return (  
    <div className="form-page-layout">
      <div className="container my-5 flex-grow-1">
          
          <div className="mb-5"> 
            <Carousel interval={5000} wrap={true} pause={false}> 
              {hardcodedImages.map((imgUrl, index) => (
                <Carousel.Item key={index}>
                  <img
                    className="d-block w-100 rounded"
                    src={imgUrl}
                    alt={`Slide ${index}`}
                    style={{ height: "800px", objectFit: "cover" }} 
                  />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          <div className="row g-4"> 
            {formsList.map((form, index) => (
              <div className="col-12" key={index}>
                <div className="form-card d-flex justify-content-between align-items-center">
                  
                  <h3 className="form-name m-0">{form.name || form.Name}</h3>
                  
                  <a 
                    href={form.link || form.Link} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="btn btn-primary form-btn"
                  >
                    Accesare
                  </a>

                </div>
              </div>
            ))}
          </div>

      </div>
    </div>
  );
}

export default FormPage;
